import { render, staticRenderFns } from "./chart-orders.vue?vue&type=template&id=6291a912"
import script from "./chart-orders.vue?vue&type=script&lang=js"
export * from "./chart-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports